
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import { NavigationOptions, PaginationOptions, SwiperOptions } from "swiper/types";

export default class Slider
{
    target: HTMLElement;
    slider: Swiper;

    navigationConfig: NavigationOptions;
    paginationConfig: PaginationOptions;

    constructor(target: HTMLElement)
    {
        this.target = target;

        this.navigationConfig = {
            nextEl: <HTMLElement>this.target.querySelector('.swiper-button-next'),
            prevEl: <HTMLElement>this.target.querySelector('.swiper-button-prev')
        };

        this.paginationConfig = {
            clickable: true,
            el: <HTMLElement>this.target.querySelector('.swiper-pagination'),
            type: 'bullets'
        };
        
        let options: SwiperOptions;
        
        if (this.target.classList.contains('partner-swiper')) {
            options = {
                modules: [
                    Navigation,
                    Pagination,
                ],
                slidesPerView: 4,
                navigation: this.navigationConfig,
                pagination: this.paginationConfig,
                autoplay: false,
                loop: false,
                speed: 1000,
                spaceBetween: 10,
                breakpoints: {
                    390: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 4 },
                },
            };
        } else if (this.target.classList.contains('image-swiper')) {
            options = {
                modules: [
                    Navigation,
                    Pagination,
                    EffectFade,
                ],
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: this.navigationConfig,
                pagination: this.paginationConfig,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                autoplay: false,
                loop: false,
                speed: 1000,
            };
        } else if (this.target.classList.contains('testimonials-swiper')) {
            options = {
                slidesPerView: 1,
                spaceBetween: 10,
                autoplay: false,
                loop: false,
                speed: 1000,
            };

            const testimonialNext = <HTMLElement>document.getElementById('testimonials-next');
            const testimonialPrev = <HTMLElement>document.getElementById('testimonials-prev');
            // on click of next/prev buttons slide the swiper
            if (testimonialNext) {
                testimonialNext.addEventListener('click', () => {
                    this.slider.slideNext();
                });
            }
            if (testimonialPrev) {
                testimonialPrev.addEventListener('click', () => {
                    this.slider.slidePrev();
                });
            }
            
        } else if (this.target.classList.contains('swiper-homehero')) {
            options = {
                modules: [
                    Navigation,
                    Pagination,
                    EffectFade,
                    Autoplay,
                ],
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: this.navigationConfig,
                pagination: this.paginationConfig,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                loop: true,
                speed: 1000,
            };
            
        } else if (this.target.classList.contains('product-swiper')) {
            options = {
                autoplay: false,
                loop: false,
                speed: 1000,
                breakpoints: {
                    390: { slidesPerView: 1, spaceBetween: 10 },
                    768: { slidesPerView: 2, spaceBetween: 10 },
                    1024: { slidesPerView: 3, spaceBetween: 40 },
                },
            };

            const testimonialNext = <HTMLElement>document.getElementById('product-swiper-next');
            const testimonialPrev = <HTMLElement>document.getElementById('product-swiper-prev');
            // on click of next/prev buttons slide the swiper
            if (testimonialNext) {
                testimonialNext.addEventListener('click', () => {
                    this.slider.slideNext();
                });
            }
            if (testimonialPrev) {
                testimonialPrev.addEventListener('click', () => {
                    this.slider.slidePrev();
                });
            }
            
        } else if (this.target.classList.contains('breadcrumbs--swiper') || this.target.classList.contains('btn-category--swiper')) {
            options = {
                modules: [
                    Navigation,
                    Pagination,
                ],
                slidesPerView: 'auto',
                navigation: this.navigationConfig,
                autoplay: false,
                loop: false,
                speed: 1000,
            };
        } else {
            options = {
                modules: [
                    Navigation,
                    Pagination,
                ],
                slidesPerView: 3,
                navigation: this.navigationConfig,
                autoplay: false,
                loop: false,
                speed: 1000,
                breakpoints: {
                    390: { slidesPerView: 1, spaceBetween: 10 },
                    768: { slidesPerView: 2, spaceBetween: 10 },
                    1024: { slidesPerView: 3, spaceBetween: 40 },
                },
            };
        }

        this.slider = new Swiper(target, options);
    }
}
